import {
  House, ShoppingBag, ShoppingCart, Star, Heart, Gift, Truck, ShieldCheck, CreditCard,
  Phone, Mail, MapPin, Clock, Search, User, Users, Bell, Check, Plus, Minus,
  ChevronDown, Menu, Tag, Percent, BadgeCheck, Award, Crown, Gem, Sparkles, Zap,
  ThumbsUp, MessageCircle, Send, Globe, Headphones, Camera, Image, Play, Music,
  Calendar, Wallet, Banknote, Package, Store, Shirt, Watch, Glasses, Palette, Leaf,
  Sun, Moon, Flame, Droplets, Key, Lock, Eye, Info, Headset, Wrench, Scissors,
  Ruler, Lightbulb, Coffee, Bookmark, Flag, Share2, Smartphone, Laptop, Armchair,
  Baby, Bike, Car, Dumbbell, Cat, Dog, Fish, Bird, Flower2, Pizza, Apple,
  GraduationCap, Briefcase, PenTool, Rocket, Anchor, Plane, Fuel, Wifi, QrCode,
  Barcode, Puzzle, Blocks, Dices, PartyPopper, PiggyBank, Coins, Receipt, FileText,
  Megaphone, Video, Medal, Trophy, Target, Compass, Navigation, Footprints,
  Mountain, Tent, TreePine, Sunset, Sunrise, Umbrella, Snowflake, CookingPot, Bath,
  Sofa, BedDouble, LampDesk, Plug, BatteryCharging, PaintRoller, Hammer, Drill,
  DoorOpen, KeySquare, CircleCheck, CircleQuestionMark, TrainFront, AtSign, Mic,
  Shell, Vault, HousePlus, ListChecks,
} from 'lucide-react';

export const ICONS = {
  House, ShoppingBag, ShoppingCart, Star, Heart, Gift, Truck, ShieldCheck, CreditCard,
  Phone, Mail, MapPin, Clock, Search, User, Users, Bell, Check, Plus, Minus,
  ChevronDown, Menu, Tag, Percent, BadgeCheck, Award, Crown, Gem, Sparkles, Zap,
  ThumbsUp, MessageCircle, Send, Globe, Headphones, Camera, Image, Play, Music,
  Calendar, Wallet, Banknote, Package, Store, Shirt, Watch, Glasses, Palette, Leaf,
  Sun, Moon, Flame, Droplets, Key, Lock, Eye, Info, Headset, Wrench, Scissors,
  Ruler, Lightbulb, Coffee, Bookmark, Flag, Share2, Smartphone, Laptop, Armchair,
  Baby, Bike, Car, Dumbbell, Cat, Dog, Fish, Bird, Flower2, Pizza, Apple,
  GraduationCap, Briefcase, PenTool, Rocket, Anchor, Plane, Fuel, Wifi, QrCode,
  Barcode, Puzzle, Blocks, Dices, PartyPopper, PiggyBank, Coins, Receipt, FileText,
  Megaphone, Video, Medal, Trophy, Target, Compass, Navigation, Footprints,
  Mountain, Tent, TreePine, Sunset, Sunrise, Umbrella, Snowflake, CookingPot, Bath,
  Sofa, BedDouble, LampDesk, Plug, BatteryCharging, PaintRoller, Hammer, Drill,
  DoorOpen, KeySquare, CircleCheck, CircleQuestionMark, TrainFront, AtSign, Mic,
  Shell, Vault, HousePlus, ListChecks,
};

export const ICON_NAMES = Object.keys(ICONS);
